import { useContext, useCallback, useEffect} from 'react';
import { Container, Row} from "react-bootstrap";
import { Web3ModalContext } from "contexts/Web3ModalProvider";
import { NotificationManager } from 'react-notifications';
import { defaultChainId, networkNames } from "blockchain/constants";
import Main from "../Main";
import Logo from "assets/logo.png";

const ComingSoon = () => {



  return (
        <div className="landing Mint-body">
          <Row className="text-center body-bg d-flex justify-content-between">
          <img src={Logo} className="landing-logo" alt="Logo" />
            <p className="upper-text">
              Coming Soon
            </p>
            
          </Row>
        </div>
  )
}

export default ComingSoon;

